
// Sélectionne l'élément audio et l'élément SVG
const audio = document.getElementById('audio');
audio.pause(); //---------------------------------------------------------------------------- a supprimer

const svgImage = document.getElementById('son');
svgImage.src = "img/son2.svg"; 

document.getElementById("son").addEventListener("click", () => {
  changeSVG();
});

// Fonction pour changer l'icône et jouer/mettre en pause le son
function changeSVG() {

  // Vérifie l'URL de l'image actuelle
  if (svgImage.src.includes("img/son2.svg")) {
      svgImage.src = "img/son1.svg"; 
      audio.pause(); // Met le son en pause
  } else {
      svgImage.src = "img/son2.svg";
      audio.play(); // Joue le son
  }
}


const observer = new MutationObserver((mutations) => {
    if (logContainer.textContent.trim().toLowerCase() === "charged") {
      closeFooter();
    }
});

observer.observe(logContainer, {
  childList: true,       // détecte les ajouts/suppressions d’éléments enfants
  characterData: true,   // détecte les changements dans le texte
  subtree: true          // observe aussi les nœuds enfants
});

const footerButton = document.getElementById('footerButton');
const footer = document.getElementById('footer');
const footerPanel = document.getElementById('footerPanel');

setTimeout(() => {
  gsap.set(footer, {
    //y: footerPanel.getBoundingClientRect().height // Utilisation de la hauteur réelle
  });  
}, 2000);  // Délai

document.getElementById("footerButton").addEventListener("click", () => {
  changeSVGfooter();
});

function changeSVGfooter() {
  
  // Vérifie l'URL de l'image actuelle
  if (footerButton.text.includes("▲")) {
    footerButton.text = "Voir moins ▼"; // Ajoute un timestamp pour éviter le cache
    openFooter();
  } else {
    footerButton.innerHTML = "Voir plus &nbsp;  &nbsp; ▲";  // Utilise innerHTML pour permettre le traitement du HTML
    closeFooter();
  }
}

function openFooter() {
  gsap.to(footer, {
    y: 0,  // Valeur d'arrivée (l'élément disparaît)
    duration: 1,  // Durée de l'animation
    ease: "power2.Out"  // Courbe d'accélération
  });

  gsap.to(footerButton, {
    y: 12,  // Valeur d'arrivée (l'élément disparaît)
    duration: 1,  // Durée de l'animation
    ease: "power2.Out"  // Courbe d'accélération
  });
  gsap.set(footerButton, {
    width: "100%",
    height: "100vh",
  });

  gsap.to(footerPanel, {
    filter: "blur(0px)",  // Valeur d'arrivée (l'élément disparaît)
    boxShadow: "inset 0px 1px 0px white",
    duration: 1,  // Durée de l'animation
    ease: "power4.Out"  // Courbe d'accélération
  });

    window.animateText("contact-p",30,0,false,1,true);
    window.animateText("contact-1",30,100,false,0.7,true);
    window.animateText("contact-2",30,200,false,0.7,true);
    window.animateText("contact-3",30,300,false,0.7,true);

    window.animateText("formations_T",30,300,false,1,true);
    window.animateText("formations_1",30,400,false,0.7,true);
    window.animateText("formations_2",30,500,false,0.7,true);
    window.animateText("formations_3",30,600,false,0.7,true);

    window.animateText("autre_T",30,600,false,1,true);
    window.animateText("autre_1",30,700,false,0.7,true);
    window.animateText("autre_2",30,800,false,0.7,true);
    window.animateText("autre_3",30,900,false,0.7,true);

    window.animateText("outilsTitre",30,1100,false,0.5,true);
    window.animateText("1_outils",30,1300,false,0.9,true);
    window.animateText("2_outils",30,1500,false,0.9,true);
    window.animateText("3_outils",30,1700,false,0.9,true);
    window.animateText("4_outils",30,1900,false,0.9,true);

    window.animateText("tdr",30,1200,false,0.5,true);

    

  
  
}

function closeFooter() {
  gsap.to(footer, {
    y: footerPanel.getBoundingClientRect().height,  // Valeur d'arrivée (l'élément disparaît)
    duration: 1,  // Durée de l'animation
    ease: "power2.Out"  // Courbe d'accélération
  });

  gsap.to(footerButton, {
    y: 0,  // Valeur d'arrivée (l'élément disparaît)
    duration: 1,  // Durée de l'animation
    ease: "power2.Out"  // Courbe d'accélération
  });
  gsap.set(footerButton, {
    width: "auto",
    height: "auto",
  });

  gsap.to(footerPanel, {
    filter: "blur(5px)",  // Valeur d'arrivée (l'élément disparaît)
    boxShadow: "inset 0px 3px 0px white",
    duration: 1,  // Durée de l'animation
    ease: "power2.Out"  // Courbe d'accélération
  });


}